module.exports = __webpack_public_path__ + "img/bitcoin-convert.465090ed.svg";